import {
  ADS_ANALYTICS_NAMESPACE,
  EMAIL_ANALYTICS_NAMESPACE,
  OTT_ANALYTICS_NAMESPACE,
  QR_CODE_LINK_ANALYTICS_NAMESPACE,
  ROI_ANALYTICS_NAMESPACE,
  SEO_ANALYTICS_NAMESPACE,
  SKAN_UNIFIED_NAMESPACE,
  SOURCE_ANALYTICS_NAMESPACE,
} from '../../../../../../shared/constants';
import {
  ADS_TABLE,
  ADS_TRENDS,
  EMAILS_TABLE,
  EMAILS_TRENDS,
  OTT_TABLE,
  OTT_TRENDS,
  OTT_WIDGETS,
  QR_CODE_LINK_TABLE,
  QR_CODE_LINK_TRENDS,
  ROI_ANALYTICS_TABLE,
  SEO_TABLE,
  SEO_TRENDS,
  SKAN_UNIFIED_TABLE,
  SOURCES_TABLE,
} from '../../../../../../shared/constants/analytics/contexts';

export const CONTEXTS = {
  [OTT_ANALYTICS_NAMESPACE]: {
    table: OTT_TABLE,
    series: OTT_TRENDS,
    widgets: OTT_WIDGETS,
  },
  [SEO_ANALYTICS_NAMESPACE]: {
    table: SEO_TABLE,
    series: SEO_TRENDS,
  },
  [QR_CODE_LINK_ANALYTICS_NAMESPACE]: {
    table: QR_CODE_LINK_TABLE,
    series: QR_CODE_LINK_TRENDS,
  },
  [ADS_ANALYTICS_NAMESPACE]: {
    table: ADS_TABLE,
    series: ADS_TRENDS,
  },
  [SKAN_UNIFIED_NAMESPACE]: {
    table: SKAN_UNIFIED_TABLE,
  },
  [SOURCE_ANALYTICS_NAMESPACE]: {
    table: SOURCES_TABLE,
  },
  [EMAIL_ANALYTICS_NAMESPACE]: {
    table: EMAILS_TABLE,
    series: EMAILS_TRENDS,
  },
  [ROI_ANALYTICS_NAMESPACE]: {
    table: ROI_ANALYTICS_TABLE,
    series: ADS_TRENDS,
  },
};
